var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPfLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 123,
    viewBox: "0 0 96 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15525_63301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.6761 22H12.222L24.5281 37.3846H61.4465L70.6761 22Z",
    fill: "#47127D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2909 25.0767L66.8304 40.4613L76.8292 54.3075L64.523 71.2306H40.6799L18.3751 102H38.3725L49.1404 86.6152H73.7526L96.0575 54.3075L75.2909 25.0767Z",
    fill: "#47127D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5024 46.6152L0 86.6153H18.5036L35.4246 61.9999H59.2677L64.6516 54.3076L59.2677 46.6152H28.5024Z",
    fill: "#7BA340"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15525_63301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 123,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfLogo1);
export default __webpack_public_path__ + "static/media/PF_Logo 1.df1552739b8e740e5ea22974479f9790.svg";
export { ForwardRef as ReactComponent };